module.exports = __webpack_public_path__ + "img/logo.a2a03c98.png";